import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.function.name.js";
import { Button, Combobox, DatePicker, Flex, Select, TextInput, createForm } from '@applyboard/crystal-ui';
import { RegistrationStatus } from "../../../data/registrations";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var _createForm = createForm(),
  Form = _createForm.Form,
  Field = _createForm.Field;
export function FilterForm(_ref) {
  var filterValues = _ref.filterValues,
    onSubmit = _ref.onSubmit,
    countries = _ref.countries;
  return _jsx(Form, {
    defaultValues: filterValues,
    onSubmit: onSubmit,
    children: _jsxs(Flex, {
      align: "end",
      justify: "start",
      direction: {
        xs: 'column',
        md: 'row'
      },
      gap: 4,
      children: [_jsx(Flex.Item, {
        children: _jsx(Field, {
          as: Select,
          label: "Status",
          name: "status",
          appearance: "styled",
          emphasis: "outlined",
          placeholder: "All",
          children: Object.values(RegistrationStatus).map(function (status) {
            return _jsx(Select.Option, {
              label: status,
              value: status
            }, status);
          })
        })
      }), _jsx(Flex.Item, {
        children: _jsx(Field, {
          as: DatePicker,
          name: "requestDateFrom",
          label: "Request date (From)",
          minDate: "1969-04-20T05:00:00.000Z",
          maxDate: filterValues.requestDateTo || '2069-05-26T03:55:00.000Z'
        })
      }), _jsx(Flex.Item, {
        children: _jsx(Field, {
          as: DatePicker,
          name: "requestDateTo",
          label: "Request date (To)",
          minDate: filterValues.requestDateFrom || '1969-04-20T05:00:00.000Z',
          maxDate: "2069-05-26T03:55:00.000Z"
        })
      }), _jsx(Flex.Item, {
        children: _jsx(Field, {
          as: TextInput,
          name: "companyName",
          label: "Company name"
        })
      }), _jsx(Flex.Item, {
        children: _jsx(Field, {
          as: TextInput,
          name: "email",
          label: "Email"
        })
      }), _jsx(Flex.Item, {
        children: _jsx(Field, {
          as: Combobox,
          name: "addressCountry",
          label: "Address country",
          placeholder: "Search or select",
          type: "search",
          size: "md",
          children: countries.map(function (country) {
            return _jsx(Combobox.Option, {
              label: country.name,
              value: country.id
            }, country.id);
          })
        })
      }), _jsx(Flex.Item, {
        children: _jsx(Field, {
          as: Combobox,
          name: "studentSource",
          label: "Student source",
          placeholder: "Search or select",
          type: "search",
          size: "md",
          children: countries.map(function (country) {
            return _jsx(Combobox.Option, {
              label: country.name,
              value: country.id
            }, country.id);
          })
        })
      }), _jsx(Flex.Item, {
        children: _jsx(Button, {
          intent: "primary",
          type: "submit",
          children: "Search"
        })
      })]
    })
  });
}